import { z } from "zod";
/**
 * A Stable's public, high-entropy lookup identifier (ARCHITECTURE.md
 * §13.2). Crockford base32 (excludes I, L, O, U to avoid transcription
 * ambiguity), fixed width, grouped for display/entry. 20 bits/char * 12
 * chars = well beyond brute-force range even before rate limiting.
 */
const PUBLIC_ID_ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const PUBLIC_ID_LENGTH = 12;
export function generateStablePublicId(random) {
    const bytes = random.randomBytes(PUBLIC_ID_LENGTH);
    let result = "";
    for (const byte of bytes) {
        result += PUBLIC_ID_ALPHABET[byte % PUBLIC_ID_ALPHABET.length];
    }
    return result;
}
/**
 * Normalizes user-entered input for exact-match lookup only: uppercased,
 * with whitespace/hyphens (display grouping) stripped. Never used for
 * partial/fuzzy matching (ARCHITECTURE.md §13.2).
 */
export function normalizeStablePublicId(rawValue) {
    return rawValue.toUpperCase().replace(/[^0-9A-Z]/g, "");
}
export const StablePublicIdSchema = z
    .string()
    .transform(normalizeStablePublicId)
    .refine((value) => value.length === PUBLIC_ID_LENGTH, {
    message: `A Stable ID must be exactly ${PUBLIC_ID_LENGTH} characters.`,
});
